function injectStyle (context) {
  require("!!../../../../../../../../../../../Volumes/DEVEL/TBAV-actual/tbav/node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../../../../../../../../../Volumes/DEVEL/TBAV-actual/tbav/node_modules/vue-loader/lib/style-compiler/index?{\"optionsId\":\"0\",\"vue\":true,\"id\":\"data-v-be29c5a0\",\"scoped\":true,\"sourceMap\":false}!../../../../../../../../../../../Volumes/DEVEL/TBAV-actual/tbav/node_modules/vue-loader/lib/selector?type=styles&index=0!./EditArtwork.vue")
}
/* script */
export * from "!!babel-loader!../../../../../../../../../../../Volumes/DEVEL/TBAV-actual/tbav/node_modules/vue-loader/lib/selector?type=script&index=0!./EditArtwork.vue"
import __vue_script__ from "!!babel-loader!../../../../../../../../../../../Volumes/DEVEL/TBAV-actual/tbav/node_modules/vue-loader/lib/selector?type=script&index=0!./EditArtwork.vue"
/* template */
import {render as __vue_render__, staticRenderFns as __vue_static_render_fns__} from "!!../../../../../../../../../../../Volumes/DEVEL/TBAV-actual/tbav/node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-be29c5a0\",\"hasScoped\":true,\"optionsId\":\"0\",\"buble\":{\"transforms\":{}}}!../../../../../../../../../../../Volumes/DEVEL/TBAV-actual/tbav/node_modules/vue-loader/lib/selector?type=template&index=0!./EditArtwork.vue"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-be29c5a0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
import normalizeComponent from "!../../../../../../../../../../../Volumes/DEVEL/TBAV-actual/tbav/node_modules/vue-loader/lib/runtime/component-normalizer"
var Component = normalizeComponent(
  __vue_script__,
  __vue_render__,
  __vue_static_render_fns__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/artworks/EditArtwork.vue
// module id = hD92
// module chunks = 0